/**
 * KB Status badge component
 */

interface KBStatusBadgeProps {
  completeness?: number;
  isBuilding?: boolean;
}

export function KBStatusBadge({ completeness, isBuilding }: KBStatusBadgeProps) {
  if (isBuilding) {
    return (
      <span className="inline-flex items-center rounded-full bg-yellow-100 px-2.5 py-0.5 text-xs font-medium text-yellow-800">
        <svg
          className="mr-1.5 h-3 w-3 animate-spin"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          ></circle>
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
        </svg>
        Building...
      </span>
    );
  }

  if (completeness === undefined || completeness === null) {
    return (
      <span className="inline-flex items-center rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-600">
        No data
      </span>
    );
  }

  const percentage = Math.round(completeness * 100);

  // Color based on completeness
  let bgColor = 'bg-red-100';
  let textColor = 'text-red-800';

  if (percentage >= 70) {
    bgColor = 'bg-green-100';
    textColor = 'text-green-800';
  } else if (percentage >= 40) {
    bgColor = 'bg-yellow-100';
    textColor = 'text-yellow-800';
  }

  return (
    <span
      className={`inline-flex items-center rounded-full ${bgColor} px-2.5 py-0.5 text-xs font-medium ${textColor}`}
    >
      KB: {percentage}%
    </span>
  );
}

export default KBStatusBadge;
